export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor:{
    marginTop:'0',
    marginLeft:'0',
    marginRight:'0',
    marginBottom:'0'
  },
  mb_infor:{
    marginTop:'0',
    marginLeft:'0',
    marginRight:'0',
    marginBottom:'0'
  },
  pc_widgets_infor: {
    height: 54
  },
  mb_widgets_infor: {
  },
  listArr: {
    module_style: 'type_0',
    note: ''
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_zhlanguage/style.js